$(function () {
  $(window).scroll(function() {
    if ($(this).scrollTop() > 0){
      $('.header').addClass("header-border");
    }
    else{
      $('.header').removeClass("header-border");
    }
  });
});
